import { get } from '../../utils/object-helpers';

$ {
    const headingId = 'addToCartDialogHeading';
    const errorImg = 'https://pics.ebaystatic.com/aw/pics/nextGenVit/imgNoImg.gif';
    const onImageError = `if (this.src !== '${errorImg}') this.src = '${errorImg}';`;
}
<if(state.open)>
    <ebay-lightbox-dialog
        class="str-add-to-cart"
        open=state.open
        on-close("closeDialog")
        aria-labelledby=headingId
        a11y-close-text=state.closeDialogText>

        <div class="str-add-to-cart__inner">
            <if(state.errorMessage)>
                <div class="str-add-to-cart__error">
                    <ebay-section-notice status="attention">
                        <div role="alert">${state.errorMessage}</div>
                    </ebay-section-notice>
                </div>
            </if>
            <else-if(state.cart)>
                <if(state.cart.error)>
                    <div class="str-add-to-cart__error">
                        <ebay-section-notice status="attention">
                            <div role="alert">
                                <h3>${state.cart.error.title}</h3>
                                <if(state.cart.error.messages)>
                                    <for|msg| of=state.cart.error.messages>
                                        <div>${msg}</div>
                                    </for>
                                </if>
                            </div>
                        </ebay-section-notice>
                    </div>
                </if>
                <else>
                    <h2 class="str-add-to-cart__header" id=headingId>
                        <ebay-confirmation-filled-24-icon/> ${state.cart.heading}
                    </h2>
                    <if(state.cart.sme)>
                        <div class="str-add-to-cart__sme">
                            <ebay-information-filled-24-icon/>
                            <div>
                                <b>${state.cart.sme.title}</b>
                                <if(state.cart.sme.messages)>
                                    <div>
                                        <for|msg| of=state.cart.sme.messages>
                                            <if(msg.text && msg.url)>
                                                <a href=msg.url target="_blank">${msg.text}</a>
                                            </if>
                                            <else>
                                                ${msg.text}
                                            </else>
                                        </for>
                                    </div>
                                </if>
                            </div>
                        </div>
                    </if>
                    <div class="str-add-to-cart__body">
                        <div class="str-add-to-cart__media">
                            <div class="str-add-to-cart__hero-image-wrap">
                                $ {
                                    const errorImg = 'https://pics.ebaystatic.com/aw/pics/nextGenVit/imgNoImg.gif'
                                    const onImageError = `if (this.src !== '${errorImg}') this.src = '${errorImg}';`
                                }
                                <img class="str-add-to-cart__hero-image"
                                    on-load("onHeroImageLoad")
                                    onerror=onImageError
                                    src=state.cart.imageUrl/>
                            </div>
                        </div>
                        <div class="str-add-to-cart__details">
                            <div class="str-add-to-cart__title">${state.cart.title}</div>
                            <if(state.cart.mskuSummary)>
                                <div class="str-add-to-cart__msku-summary">${state.cart.mskuSummary}</div>
                            </if>
                            <div class="str-add-to-cart__quantity">${state.cart.quantity}</div>
                            <div class="str-add-to-cart__prices">
                                <if(input.cartVersion === 1)>
                                    <for|price| of=state.cart.prices>
                                        $ {
                                            const valueClass = price.value.style ? price.value.style.toLowerCase() : '';
                                        }
                                        <div/>
                                        <div class=`str-add-to-cart__prices__value ${valueClass}`>
                                            ${price.value.text}
                                        </div>
                                    </for>
                                </if>
                                <else>
                                    <for|price| of=state.cart.prices>
                                        $ {
                                            const labelClass = price.label.style ? price.label.style.toLowerCase() : '';
                                            const colspanClass = '';
                                            if (price.label && !price.value.text) {
                                                colspanClass = 'colspan2';
                                            }
                                        }
                                        <div class=`str-add-to-cart__prices__label ${labelClass} ${colspanClass}`>
                                            <if(price.label && price.label.text)>
                                                ${price.label.text}:
                                            </if>
                                        </div>
                                        $ {
                                            const valueClass = price.value.style ? price.value.style.toLowerCase() : '';
                                        }
                                        <div class=`str-add-to-cart__prices__value ${valueClass}`>
                                            <if(price.label)>
                                                ${price.value.text}
                                            </if>
                                            <else>
                                                (${price.value.text})
                                            </else>
                                        </div>
                                    </for>
                                </else>
                            </div>
                            <if(state.cart.taxDisclaimer)>
                                <div class="str-add-to-cart__tax-disclaimer">
                                    ${state.cart.taxDisclaimer}
                                </div>
                            </if>
                        </div>
                    </div>
                    <div class="str-add-to-cart__footer">
                        <if(state.cart.secondaryButton.text)>
                            <ebay-button
                                class="str-add-to-cart__secondary-btn"
                                href=state.cart.secondaryButton.url
                                data-track=state.cart.secondaryButton.tracking
                                size="large"
                                priority="secondary">

                                ${state.cart.secondaryButton.text}
                            </ebay-button>
                        </if>
                        <if(state.cart.primaryButton.text)>
                            <ebay-button
                                class="str-add-to-cart__primary-btn"
                                href=state.cart.primaryButton.url
                                data-track=state.cart.primaryButton.tracking
                                size="large"
                                priority="primary">

                                ${state.cart.primaryButton.text}
                            </ebay-button>
                        </if>
                    </div>
                </else>
            </else-if>
        </div>
        <if(state.renderSpinner)>
            <div on-transitionend("removeSpinner") class=`str-add-to-cart__spinner ${state.spinnerFadeOutClass}`>
                <ebay-progress-spinner
                    class="str-add-to-cart__spinner-icon"
                    size="large"
                    aria-live="polite" 
                    aria-label=input.spinnerText/>
                <div class="str-add-to-cart__spinner-mask"/>
            </div>
        </if>
    </ebay-lightbox-dialog>
</if>
